import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LendersService } from '../../services/lenders.service';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';

@Component({
  selector: 'app-lenders-add',
  templateUrl: './lenders-add.component.html',
  styleUrls: ['./lenders-add.component.css']
})
export class LendersAddComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    addLenderFormGroup: FormGroup;

    constructor(
        private lendersService: LendersService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Lender', breadcrumbs: [
                { title: 'Lenders', url: ['/lenders'] }
            ]
        }

        this.initializeForm();
    }

    initializeForm(): void {
        this.addLenderFormGroup = this.fb.group(
            {
                name: ['', Validators.required]
            }
        );
    }

    addLender(): void {
        this.submitAttempt = true;
        if (this.addLenderFormGroup.valid) {

            const formValue = this.addLenderFormGroup.value;
            this.lendersService.create(formValue).subscribe(
                lenderId => {
                    this.router.navigate(['./lenders/edit/' + lenderId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
